import SEO, { breadcrumbSchema } from "../components/SEO";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { FleetCard, SectionHead } from "../components/Cards";
import Reveal from "../components/Reveal";
import { FLEET } from "../data/content";
import { FLEET_HI } from "../data/hindi";
import { useLang } from "../i18n";
import { IMAGES } from "../data/site";
import { Info } from "lucide-react";

export default function Fleet() {
  const { lang, t } = useLang();
  const fleet = FLEET.map((v) => (lang === "hi" && FLEET_HI[v.id] ? { ...v, ...FLEET_HI[v.id] } : v));

  return (
    <>
      <SEO
        title="My Fleet — Sedans, SUVs & Tempo Travellers in Jodhpur"
        description="Explore the Blue City Taxi fleet in Jodhpur: AC sedans, SUVs, premium SUVs, luxury sedans and 12–26 seater tempo travellers for Rajasthan travel."
        path="/fleet"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "My Fleet", path: "/fleet" }])]}
      />
      <PageHero
        title={t("pFleetTitle")}
        subtitle={t("pFleetSub")}
        image={IMAGES.suv}
        crumbs={[{ label: "Home", to: "/" }, { label: t("navFleet") }]}
      />
      <section className="max-w-7xl mx-auto px-6 py-16">
        <SectionHead eyebrow={t("pFleetEyebrow")} title={t("pFleetHead")} />
        <Reveal className="max-w-2xl mx-auto mt-6">
          <p className="flex items-start gap-2 text-[13px] text-slate-500 bg-gold-light border border-gold/30 rounded-xl px-4 py-3">
            <Info size={15} className="text-gold-dark mt-0.5 shrink-0" />
            {t("fleetNote")}
          </p>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {fleet.map((v, i) => <FleetCard key={v.id} v={v} i={i} />)}
        </div>
      </section>
      <CtaBand title={t("fleetCtaTitle")} text={t("fleetCtaText")} />
    </>
  );
}
